export default __webpack_public_path__ + "static/media/alamo-arte-5.e5389774.webp";